import { redirect } from 'react-router-dom';
import { fetchCabinetStatus } from '@/pages/Cabinet/api/requests';
import { CabinetStatuses } from '@/pages/Cabinet/types';

export const repeatLoanLoader = async () => {
  const token = localStorage.getItem('token') || '';
  const response = await fetchCabinetStatus(token);
  if (response?.component !== CabinetStatuses.repeat) {
    return redirect('/cabinet', { status: 301 });
  }
  return null;
};
